import React, { useState } from "react";
import axios from "axios";
import ForecastInfo from "./ForecastInfo";

import "./Forecast.css";

export default function Forecast(props) {
		const [ready, setReady] = useState(false);
		const [forecast, setForecast] = useState(null);

    function handleForecast(response) {
			setForecast(response.data);
			setReady(true);
    }

    if (ready && props.city === forecast.city.name) {
      return (
				<div className="row forecast">
					<ForecastInfo data={forecast.list[0]} />
        	<ForecastInfo data={forecast.list[1]} />
        	<ForecastInfo data={forecast.list[2]} />
        	<ForecastInfo data={forecast.list[3]} />
        	<ForecastInfo data={forecast.list[4]} />
        	<ForecastInfo data={forecast.list[5]} />
				</div>
			);
    } else {
      const apiKey = "3f4a81b7800c9c7008887814c1af70f7";
    	let apiUrl = `https://api.openweathermap.org/data/2.5/forecast?q=${props.city}&appid=${apiKey}&units=metric`;
    	axios.get(apiUrl).then(handleForecast);
			
			return "This page is loading...";
    }
}